export * from "./manufacturing-material-categories.constants";
export * from "./manufacturing-vendors.constants";

export const SERVICE_PROGRAM_CATEGORIES = {
    UNIT: { text: "상시지원", value: "UNIT" },
    TOTAL: { text: "공모지원", value: "TOTAL" },
};

export const USER_TYPES = { INDIVIDUAL: "USER_INDIVIDUAL", ORGANIZATION: "USER_ORGANIZATION" };

export const INDIVIDUAL_KINDS = { SUPPORTER: "전자제조지원단", STUDENT: "인력양성사업참여학생", ELSE: "기타" };

export const EXPERT_DESCRIPTION_TERMS = ["기술정보", "학위", "지식재산권", "논문", "제품", "서비스", "기타"];

export const RENTAL_SUBJECT_TYPES = {
    EQUIPMENTS: { value: "EQUIPMENTS", text: "장비" },
    FACILITIES: { value: "FACILITIES", text: "시설" },
};

export const PROGRAM_APPLICATION_STATES = {
    APPLIED: { value: "APPLIED", text: "신청완료" },
    CANCELED: { value: "CANCELED", text: "신청취소" },
    APPROVED: { value: "APPROVED", text: "승인완료" },
    REJECTED: { value: "REJECTED", text: "승인거절" },
};

export const RENTAL_SCHEDULE_STATES = {
    APPLIED: { value: "APPLIED", text: "승인대기" },
    CANCELED: { value: "CANCELED", text: "신청취소" },
    APPROVED: { value: "APPROVED", text: "신청완료" },
    REJECTED: { value: "REJECTED", text: "승인거절" },
};

export const RENTAL_LIMITATION_TYPES = {
    PER_WEEK: { value: "PER_WEEK", text: "주별 제한" },
};
